import { findShellHeader } from './theme-mode';

const LOGOUT_BUTTON_SELECTOR = '[data-header-logout]';
const LOGOUT_BOUND_ATTR = 'data-header-logout-bound';

let logoutDialogRedirectsBound = false;

function bindLogoutDialogRedirects(logoutDialog: Element): void {
  if (logoutDialogRedirectsBound) {
    return;
  }

  logoutDialogRedirectsBound = true;

  logoutDialog.addEventListener('auth-logout', () => {
    window.location.href = '/auth/logout';
  });

  logoutDialog.addEventListener('app-logout', () => {
    window.location.href = '/auth/logout?app_logout=1';
  });
}

type CbarAppLogoutElement = HTMLElement & {
  open?: boolean;
};

export function openLogoutDialog(): boolean {
  const logoutDialog = document.querySelector('cbar-app-logout') as CbarAppLogoutElement | null;

  if (!logoutDialog) {
    return false;
  }

  bindLogoutDialogRedirects(logoutDialog);

  // v7: `open` is the canonical boolean; `opened` remains an alias for this major.
  logoutDialog.open = true;

  return true;
}

const handleLogout = (e: Event) => {
  e.preventDefault();
  e.stopImmediatePropagation();

  openLogoutDialog();
};

export function bindHeaderLogoutButtons(): void {
  document.querySelectorAll(LOGOUT_BUTTON_SELECTOR).forEach((node) => {
    if (node.getAttribute(LOGOUT_BOUND_ATTR) === 'true') {
      return;
    }

    node.setAttribute(LOGOUT_BOUND_ATTR, 'true');
    node.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      handleLogout(event);
    });
  });
}

function bindLegacyLogoutButton(): void {
  const logoutButton = document.querySelector('a.logout_button');

  if (!logoutButton || logoutButton.getAttribute(LOGOUT_BOUND_ATTR) === 'true') {
    return;
  }

  logoutButton.setAttribute(LOGOUT_BOUND_ATTR, 'true');
  logoutButton.setAttribute('href', '');
  logoutButton.addEventListener('click', handleLogout);
}

function bindShellHeaderLogout(): void {
  const header = findShellHeader();

  if (!header || header.getAttribute('data-shell-logout-bound') === 'true') {
    return;
  }

  header.setAttribute('data-shell-logout-bound', 'true');
  header.addEventListener('logout', handleLogout, { capture: true });
}

export const setupLogoutHandler = () => {
  const shell = document.querySelector('#app-shell, #admin-shell');
  const logoutButton = document.querySelector('a.logout_button');

  if (!shell && !logoutButton) {
    bindHeaderLogoutButtons();
    bindShellHeaderLogout();
    return;
  }

  bindLegacyLogoutButton();
  bindHeaderLogoutButtons();
  bindShellHeaderLogout();
};
